import client from '../../../api'
import type { RequestConfig, ResponseErrorConfig } from '../../../api'
import type {
  ApplicationAiTestControllerGetSchoolsAiTestByIinQueryResponse,
  ApplicationAiTestControllerGetSchoolsAiTestByIinPathParams,
} from '../../ts/Application-AI-TestDTO/ApplicationAiTestControllerGetSchoolsAiTestByIin'

export function getApplicationAiTestControllerGetSchoolsAiTestByIinUrl({ iin }: { iin: ApplicationAiTestControllerGetSchoolsAiTestByIinPathParams['iin'] }) {
  return `/application-ai-test/${iin}/ai-test-schools` as const
}

/**
 * @summary Получить список школ для обучения в АИ Тест
 * {@link /application-ai-test/:iin/ai-test-schools}
 */
export async function applicationAiTestControllerGetSchoolsAiTestByIin(
  { iin }: { iin: ApplicationAiTestControllerGetSchoolsAiTestByIinPathParams['iin'] },
  config: Partial<RequestConfig> & { client?: typeof client } = {},
) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<ApplicationAiTestControllerGetSchoolsAiTestByIinQueryResponse, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getApplicationAiTestControllerGetSchoolsAiTestByIinUrl({ iin }).toString(),
    ...requestConfig,
  })
  return res
}